import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import type { ExperimentalSpaceProperty } from '../__types__/ExperimentalSchema';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalSpaceProperties: ExperimentalQueries['experimentalSpaceProperties'] = (
	_,
	{ spaceKey, propertyKeys },
	{ network },
): Promise<ExperimentalSpaceProperty[]> => {
	if (!spaceKey || !propertyKeys || !propertyKeys.length) {
		return Promise.reject(new Error('Space key and at least one property key must be specified'));
	}

	const fetchSpaceProperty = (propertyKey: string) =>
		fetchJSON(network, `/wiki/rest/api/space/${spaceKey}/property/${propertyKey}`, {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		});

	return Promise.allSettled(propertyKeys.map((key) => fetchSpaceProperty(key))).then((results) =>
		(
			results.filter((result) => result.status === 'fulfilled') as PromiseFulfilledResult<any>[]
		).map(({ value: property }) => ({
			...property,
			value: JSON.stringify(property.value),
		})),
	);
};
